const initialState = {
    stores: {
      areaManagers: [],
      peerGroups: [],
      regions: [],
      translation: null,
      storesCodeNameList: null,
      dataAccessStores: [],
      myStores: [],
    },
    apiStores:{},
  };
  
  export default initialState;